import React,{ useEffect } from 'react';
import spice from '../assets/spice.jpg';
import '../styles/home.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { motion } from "framer-motion";
import spices from '../data/data';
function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation(); // Initialize useTranslation

  const handleClick = () => {
    navigate('/spice');
  };
 const fadeInUp = {
  initial:{ opacity: 0, y: 40 },
  animate:{ opacity: 1, y: 0 },
  transition:{ duration: 0.8 }
};
  useEffect(() => {
    spices.forEach(spice => {
      const img = new Image();
      img.src = spice.image;
    });
  }, []);
  return (
    <div>
      <div
        className="home-bg"
        style={{
          backgroundImage: `url(${spice})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '100vh',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
        }}
      >
        <div className='info'>
          <motion.div {...fadeInUp}>
          <h2 className='heading'
          >{t('papilla')}</h2>
          <h3 className='tagline'>{t('pure_perfection')}</h3>
          <p className='description'>{t('spices_description')}</p>
          <button className="oval-button" onClick={handleClick}>
            {t('our_products')}
          </button>
          </motion.div>
        </div>
      </div>
      <motion.div initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }} className='about'>
        <h2>{t('our_legacy')}</h2>
        <p className='moredescription'>
          {t('legacy_description')}
        </p>
      </motion.div>
      <div className='footer'>
        <p className='foot-head'>{t('company_name_full')}</p>
        <p>No: 37/953, 24th Main, JP Nagar II Phase, Bangalore-560078</p>
        <p>{t('all_rights_reserved', { year: new Date().getFullYear() })}</p>
      </div>
    </div>
  );
}

export default Home;